import { Routes, Route, Navigate } from 'react-router-dom';
import React from 'react';
import MainRoute from 'containers/SiteRoute/Main';
import ProtectedRoute from 'containers/ProtectedRoute';
import NoticePage from 'pages/Notice';
import DynamicBoard from 'pages/Board/DynamicBoard';
import CalendarPage from 'pages/Calendar';
import AdminRoutes from './Admin';
import TestRoutes from './Test';
import AccountRoutes from './Account';
import SiteList from 'pages/Sites/SiteList';  // Site list page
import SiteDetail from 'pages/Sites/SiteDetail';
import SiteRouter from 'pages/Sites/SiteRouter';
import ArticleEditor from 'pages/Admin/Articles/Editor';
import ArticleViewer from 'pages/Admin/Articles/Viewer';

export default () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={'/main/home/'} />}></Route>
      <Route path="/main/*" element={<MainRoute />}></Route>
      <Route path="/notice" element={<NoticePage />}></Route>
      {/* 동적 게시판 라우트 - ID 기반 */}
      <Route path="/board/:boardId" element={<DynamicBoard />}></Route>
      <Route path="/calendar" element={<CalendarPage />}></Route>
      {/* 현장자료실 라우트 - 순서 중요: 구체적인 경로를 먼저 */}
      <Route path="/sites/list" element={<SiteList />}></Route>
      <Route path="/sites" element={<SiteRouter />}></Route>
      <Route path="/sites/:siteId" element={<SiteDetail />}></Route>
      {/* 기존 라우트 - 추후 제거 예정 */}
      <Route path="/boards/:boardId/articles/editor" element={<ArticleEditor />}>
        <Route path=":articleId" element={<ArticleEditor />}></Route>
      </Route>
      <Route path="/boards/:boardId/articles/:articleId" element={<ArticleViewer />}></Route>
      <Route path="/admin/*" element={<ProtectedRoute><AdminRoutes /></ProtectedRoute>}></Route>
      <Route path="/account/*" element={<AccountRoutes />}></Route>
      <Route path="/test/*" element={<TestRoutes />}></Route>
    </Routes>
  );
};
